// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","5336": "5083bc5218c4","74": "03f30ee38e6c","8942": "f06e52cc1430",}[chunkId] + ".css"
}